"use client";

import { c as _c } from "react/compiler-runtime";
import type { QueryStatus } from "@tanstack/react-query";
import { useState } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import UserPageBrainSidebarWaveItem from "./UserPageBrainSidebarWaveItem";
interface UserPageBrainSidebarCreatedProps {
  readonly identity: string;
  readonly waves: ApiWave[];
  readonly status: QueryStatus;
}
export default function UserPageBrainSidebarCreated(t0) {
  const $ = _c(11);
  const {
    identity,
    waves,
    status
  } = t0;
  const [expandedIdentity, setExpandedIdentity] = useState(null);
  const showAllWaves = expandedIdentity === identity;
  let t1;
  if ($[0] !== showAllWaves || $[1] !== waves) {
    t1 = showAllWaves ? waves : waves.slice(0, 1);
    $[0] = showAllWaves;
    $[1] = waves;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const visibleWaves = t1;
  const remainingWavesCount = Math.max(waves.length - 1, 0);
  const showMoreLabel = remainingWavesCount === 1 ? "Show 1 more" : `Show ${remainingWavesCount} more`;
  const shouldShowLoading = status === "pending" && waves.length === 0;
  const shouldShowWaves = waves.length > 0;
  if (!shouldShowLoading && !shouldShowWaves) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span id="brain-created-waves-heading" className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Created Waves</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== identity || $[5] !== shouldShowLoading || $[6] !== showAllWaves || $[7] !== showMoreLabel || $[8] !== visibleWaves || $[9] !== waves.length) {
    t3 = <section aria-labelledby="brain-created-waves-heading">{t2}<div className="tw-mt-3 tw-space-y-2.5">{shouldShowLoading ? <div className="tw-space-y-2.5" aria-label="Loading created waves">{[0, 1, 2].map(_temp)}</div> : <>{visibleWaves.map(_temp2)}{waves.length > 1 && <button type="button" onClick={() => setExpandedIdentity(current => current === identity ? null : identity)} className="tw-mt-2 tw-cursor-pointer tw-border-none tw-bg-black tw-px-1 tw-text-xs tw-font-semibold tw-text-iron-500 tw-transition-colors desktop-hover:hover:tw-text-iron-300">{showAllWaves ? "Show less" : showMoreLabel}</button>}</>}</div></section>;
    $[4] = identity;
    $[5] = shouldShowLoading;
    $[6] = showAllWaves;
    $[7] = showMoreLabel;
    $[8] = visibleWaves;
    $[9] = waves.length;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp2(wave) {
  return <UserPageBrainSidebarWaveItem key={wave.id} wave={wave} />;
}
function _temp(key) {
  return <div key={key} className="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-white/5 tw-p-3 tw-shadow-inner"><div className="tw-h-10 tw-w-10 tw-shrink-0 tw-animate-pulse tw-rounded-full tw-bg-white/[0.06]" /><div className="tw-min-w-0 tw-flex-1 tw-space-y-1.5"><div className="tw-h-3 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-white/[0.06]" /><div className="tw-h-2.5 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-white/[0.05]" /></div></div>;
}